import { render, staticRenderFns } from "./composantAdminBDD.vue?vue&type=template&id=d2729288&scoped=true"
import script from "./composantAdminBDD.vue?vue&type=script&lang=js"
export * from "./composantAdminBDD.vue?vue&type=script&lang=js"
import style0 from "./composantAdminBDD.vue?vue&type=style&index=0&id=d2729288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2729288",
  null
  
)

export default component.exports